import PropTypes from 'prop-types';
import * as yup from 'yup';


export const COUNTRY_ALPHA2_SHAPE = PropTypes.string;
export const COUNTRY_ALPHA3_SHAPE = PropTypes.string;
export const COUNTRY_CODE_SHAPE = PropTypes.string;
export const COUNTRY_NAME_SHAPE = PropTypes.string;


export const COUNTRY_SHAPE = PropTypes.shape({
    alpha2: COUNTRY_ALPHA2_SHAPE,
    alpha3: COUNTRY_ALPHA3_SHAPE,
    countryCode: COUNTRY_CODE_SHAPE,
    name: COUNTRY_NAME_SHAPE
});

export const REGION_SHAPE = PropTypes.shape({
    counties: PropTypes.arrayOf(COUNTRY_SHAPE).isRequired,
    region: PropTypes.string.isRequired,
    regionCode: PropTypes.string.isRequired
});

export const REGIONS_SHAPE = PropTypes.arrayOf(REGION_SHAPE);


export const SCHEMA_COUNTRY_ALPHA2 = yup.string()
    .nullable()
    .length(2)
    .required();

export const SCHEMA_REGION = yup.string()
    .nullable()
    .max(3) // alpha-3 ISO code
    .min(3) // alpha-3 ISO code
    .required();


export const SCHEMA_GEO = yup.object()
    .shape({
        countryAlpha2: SCHEMA_COUNTRY_ALPHA2,
        region: SCHEMA_REGION
    });
